import { MEDIA_QUERIES } from '../config'
import { pickElement } from './utils'

export function openModal(element) {
  if (element) {
    element.addEventListener('click', (event) => {
      event.preventDefault()
      if (!window.DFI.ModalView) {
        window.DFI.initModalView()
      }
      window.DFI.ModalView.open()
    })
  }
}

export function activeModalInDevice() {
  const askForBudgetDesktop = pickElement('.c-link.u-text-hyphen-manual')
  const askForBudgetMobile = pickElement(
    '.c-header-mobile__service-link .c-link'
  )

  window.innerWidth >= MEDIA_QUERIES.tablet
    ? openModal(askForBudgetDesktop)
    : openModal(askForBudgetMobile)
}
